module.exports = __webpack_public_path__ + "static/media/notFound.dd230281.png";